<template>
  <div class="auth-code-container">
    <h2 class="auth-title">
      {{ $t('Verify your email') }}
    </h2>
    <span class="text text-grey">
      {{ $t('We’ve sent code to') }} {{ registrationInfo.email }}.
      {{ $t('Check your inbox') }}
    </span>

    <div class="code-input-wrapper">
      <CodeInput
        :length="4"
        :warning="warning"
        :success="success"
        @send="handleSending"
        @resend="handleResending"
      />
      <Button
        class="code-input-previous-btn spacex-6"
        color="neutral"
        size="small"
        @click="$emit('change-step', 1)"
      >
        <div class="spacex-6 flex-row flex-centering">
          <BackIcon class="icon-black" />
          <div>{{ $t('Previous') }}</div>
        </div>
      </Button>
    </div>
  </div>
</template>

<script>
  import CodeInput from '@/components/ui/CodeInput';
  import { mapActions, mapState } from 'vuex';
  import request from '@/utils/api/request';
  import Button from '@/components/ui/Button';
  import BackIcon from '@/assets/icons/arrow-left-black.svg';

  export default {
    name: 'CodeRegister',
    components: {
      CodeInput,
      Button,
      BackIcon,
    },
    data() {
      return {
        warning: false,
        success: false,
      };
    },
    computed: {
      ...mapState('auth', ['registrationInfo', 'password']),
    },
    methods: {
      ...mapActions('auth', ['login', 'setToken']),
      async handleSending(hash) {
        try {
          let { data } = await request.post('/confirm_email/', {
            hash,
          });

          this.setToken(data.register_finish_token);
          this.success = true;

          this.$emit('change-step', 3);
        } catch (e) {
          this.warning = true;
        }
      },
      async handleResending() {
        await request.post('/resend_confirm_email/', {
          email: this.registrationInfo.email,
        });
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/code-input';
</style>
